import React, { useContext } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import AntiCorruption from '../components/Achievements/AntiCorruption';
import Introduction from '../components/Achievements/Introduction';
import Privacy from '../components/Achievements/Privacy';
import Download from '../components/Home/Download';
import AchievementsBanner from '../components/Achievements/AchievementsBanner';
import { isMobileContext } from '../components/context/isMobileContext';
export default function Community() {
    const {t} = useTranslation();
    const {isMobile}=useContext(isMobileContext)
    const bannerData = {
        our: t("community_page.banner.our"),
        headline1: t("community_page.banner.headLine1"),
        headline2: t("community_page.banner.headLine2-1"),
        description: t("community_page.banner.description"),
        worldClass: t("community_page.banner.world_class"),
        img: '/imgs/achievements/community-banner.png'
      }
      const responsibilityData = {
        line1: t("community_page.responsibility.line1"),
        line2: t("community_page.responsibility.line2"),
        line3: t("community_page.responsibility.line3"),
        description : t("community_page.responsibility.description1"),
          // t("community_page.responsibility.description2")
        
        img: '/imgs/achievements/responsibility.png'
      }
      const womenData = {
        line1: t("community_page.women.line1"),
        line2: t("community_page.women.line2"),
        line3: t("community_page.women.line3"),
        descriptions : [
          t("community_page.women.description1"),
          t("community_page.women.description2")
        ],
        img: '/imgs/achievements/huh-women1.png'
      } 
      const initiativesData = {
        line1: t("community_page.initiatives.line1"),
        line2: t("community_page.initiatives.line2"),
        line3: t("community_page.initiatives.line3"),
        descriptions : [
          t("community_page.initiatives.description1"),
        ],
        img: '/imgs/achievements/initiatives1.png'
      }
      const humanRightsData = {
        line1: t("community_page.human_rights.line1"),
        line2: t("community_page.human_rights.line2"),
        descriptions: [
            t("community_page.human_rights.description1")
        ],
        img: '/imgs/achievements/human-rights.png'
      }
      const partnershipsData = {
        line1: t("community_page.partnerships.line1"),
        line2: t("community_page.partnerships.line2"),
        description: t("community_page.partnerships.description")
        
      } 
      const SMEData = {
        line1: t("community_page.sme.line1"),
        descriptions: [
            t("community_page.sme.description1")
        ], 
        img: '/imgs/achievements/sme.png'
      }

  return (
    <div>
        <Helmet>
            <title>{t('head.community')}</title>
        </Helmet>
        <AchievementsBanner bannerData={bannerData}  uniqueClass={"community"}/>
        {/* <Introduction uniqueClass={"community"}/> */}
        <AntiCorruption normalSwiperLayers={isMobile?true:false} data={responsibilityData} privacyLayer1 uniqueClass={"community"}/> 
        {/* <Privacy data={responsibilityData}  noPaddingEnd uniqueClass={"community"}/> */}
        <Privacy data={womenData} WomenSection privacyLayer2 invertedSection noPaddingStart  uniqueClass={"community"}/>
        <Privacy data={initiativesData} privacyLayer1  SocialResponsibility  noPaddingEnd uniqueClass={"community"}/>
        <Privacy data={humanRightsData} HumenRight  invertedSection noPaddingStart uniqueClass={"community"}/>
        <AntiCorruption data={partnershipsData} privacyLayer2  uniqueClass={"community"}/>
        <Privacy data={SMEData} SupportSection communityPage={isMobile?true:false} removeImg={isMobile?true:false}  uniqueClass={"community"}/>
        {/* <Download/> */}
    </div>
  )
}
